<template>
  <SwitchGroup as="div" class="flex items-center">
    <Switch
      v-model="model"
      :class="[
        model ? 'bg-bkk-100 ' : 'bg-white border border-mid-gray',
        'relative inline-flex h-[32px] w-[52px] shrink-0 cursor-pointer rounded-full transition-colors duration-200 ease-in-out',
      ]"
    >
      <span
        aria-hidden="true"
        :class="[
          model
            ? 'translate-x-[22px] bg-white size-[24px] translate-y-[4px]'
            : 'translate-x-[6px] bg-mid-gray size-[17px] translate-y-[7px]',
          'inline-block transform rounded-full shadow ring-0 transition duration-200',
        ]"
      />
    </Switch>
    <SwitchLabel as="span" class="ml-3 text-sm">
      <span
        v-if="labelEvent"
        class="cursor-pointer underline"
        @click="labelEvent?.()"
      >
        {{ label }}
      </span>
      <span v-else>{{ label }}</span>
    </SwitchLabel>
  </SwitchGroup>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { Switch, SwitchGroup, SwitchLabel } from "@headlessui/vue";

const props = defineProps<{
  modelValue: boolean;
  label?: string;
  labelEvent?: () => void;
}>();

const emit = defineEmits<{
  (e: "update:modelValue", value: boolean): void;
}>();

const model = computed({
  get: () => props.modelValue,
  set: (val) => emit("update:modelValue", val),
});
</script>
